module.exports = __webpack_public_path__ + "img/user_name.80dfed54.png";